import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
//import template = require('dojo/text!./ProjectFinder2Home.html');
import topic from 'dojo/topic';
import "../ProjectFinder2/ProjectFinder2HomeTypes";
import { ProjectWizardV2 as ProjectWizard, EvBookingAgenda, ProjectView } from '../_loadingHelpers/VAMv2';
import { VAM2types } from '../_loadingHelpers/VAMv2Types';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import FinderBaseV2 from '../FinderBase/FinderBaseV2';

class ProjectFinderHomeLM extends compose(FinderBaseV2) {
    //templateString = template;


    private requestNewEntity() {
        topic.publish("ProjectFinder2/RequestNew");
    }

    private _onClick_Row(row: StaticTable.StaticTableRow<VAM2types.EvProjectEntity_Base>) {
        let entity = row.rowGroup.entity;
        let label = "";
        let entityId = entity.ID;

        if (!entityId) return;


        let view = new ProjectView();
        view.showAsDlg(entityId, entity.ev_project_name, this.getTabContainerName());

        //if (this.hasUserRole("Projects_Edit")) {
        //    view.forceOpenEditor(entityId, entity.Classname, entity.ev_project_name, this.getTabContainerName());
        //} else {
        //    view.showAsDlg(entityId, entity.ev_project_name);
        //}

        view.on("change", lang.hitch(this, this.reload));
        view.on("deleted", lang.hitch(this, this.reload));
    }

    private _onCloseDetailsDlg_Callback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof ProjectWizard>>) {
        let hasChanged = form.isDirty();
        if (hasChanged) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.show(this.translations["General_AskSavePendingChanges"],
                this.translations["General_PendingChanges"],
                "",
                "",
                "yesno",
                lang.hitch(this, this._confirmCallback, dlg, form)
            );

        } else {
            dlg.close();
        }
    }

    private _confirmCallback(dlg: MdsLax<InstanceType<typeof GenericDialog>>, form: MdsLax<InstanceType<typeof ProjectWizard>>, result) {
        if (result == -1) { // nein - nicht speichern
            dlg.close();
        } else {
            form.on("saveComplete", lang.hitch(dlg, dlg.close))
            form.save();
        }
    }

    private projectTable_formatterFunction(cell: StaticTable.StaticTableCell<any>) { // formatter
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {

            case "date":
                let dateFrom = entity.date_start;
                let dateTo = entity.date_end;

                let txtDateFrom = "?";
                let txtdateTo = "?";

                if (dateFrom) {
                    txtDateFrom = this.dojoDate.format(new Date(dateFrom), {
                        datePattern: "dd.MM.yyyy",
                        timePattern: "HH:mm",
                        selector: "date"
                    });
                }

                if (dateTo) {
                    txtdateTo = this.dojoDate.format(new Date(dateTo), {
                        datePattern: "dd.MM.yyyy",
                        timePattern: "HH:mm",
                        selector: "date"
                    });

                }
                node.innerHTML = this.stringFormat(this.translations["ProjectList_DateRangeFormat"], txtDateFrom, txtdateTo);
                this.UiModder.domClass.add(node, "projectlist_DateRange");
                return true;
                break;
            case "note":
                if (cell.value == "" || cell.value == null) {
                    this.UiModder.domClass.add(cell.tableRow.node, "w3-hide");
                }
                return true;
                break;

            default:
                return false;
        }
    }


    _onEmbedding(): void {

        //this.requestContextButton({
        //    callback: null,
        //    label: "LM Menüeintrag",
        //    permanent: false,
        //    heading: "Projekt LM",
        //    order: 12,
        //    placement: "topmenu"
        //});

        //this.requestContextButton({
        //    callback: null,
        //    label: "LM Menüeintrag permanent!",
        //    permanent: true,
        //    heading: "Projekt LM",
        //    order: 12,
        //    placement: "topmenu"
        //});

        //this.requestContextButton({
        //    callback: lang.hitch(this, function () { console.log("BUBUBU"); }),
        //    label: "Irgendeine Aktion",
        //    placement: "actionbar",
        //    permanent: true,
        //    //heading: "Übi1",
        //    order: 100
        //});

        //this.requestContextButton({
        //    callback: lang.hitch(this, function () { console.log("BUBUBU"); }),
        //    label: "BUBUBU",
        //    placement: "actionmenu",
        //    permanent: true,
        //    //heading: "Übi1",
        //    order: 100
        //});

        //this.requestContextButton({
        //    callback: lang.hitch(this, function () { console.log("item2"); }),
        //    label: "item2",
        //    placement: "actionmenu",
        //    permanent: true,
        //    //heading: "Übi1",
        //    order: 101
        //});

    }

    private onHideTime: Date = null;

    public _onActivated() {
        //damit wir nicht staendig neu laden sondern nur wenn der user von der history lang genug weg war
        const RELOAD_DELAY_MS = 8_000;
        if (this.onHideTime == null) {
            return;
        }
        const timeSinceHide = new Date().getTime() - this.onHideTime.getTime();
        if (timeSinceHide >= RELOAD_DELAY_MS) {
            this.onHideTime = null;
            this.reload();
        }
    }

    public _onHide() {
        this.onHideTime = new Date();
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (this.hasFeature("PlanningSection","killProjectFinderLM")){
            try{
                (this.destroyRecursive as any)();
            }catch{}
            return;
        }

        this.RequestManager.handleAs = "json";

        this.setupFinder(
            "ProjectFinder2/GetFinderConfigurationLM",
            "ProjectFinder2/GetProjectListLM",
            lang.hitch(this, this._onClick_Row),
            lang.hitch(this, this.projectTable_formatterFunction)
        );

        this.addSubscription("EvProject/Cloned", lang.hitch(this, this.reload));
        this.addSubscription("EvProject/Deleted", lang.hitch(this, this.reload));

    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProjectFinderHomeLM);
